<div class="top-btn" (click)="jumbToTop()" title="Move to top" *ngIf="showTopBtn">
    <i class="fas fa-chevron-up"></i>
</div>
